// ------------------------------------
// Imports
// ------------------------------------

import { API_REQUEST_STATUS_LOADING, API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'

// ------------------------------------
// Constants
// ------------------------------------

/* obtener el token */
export const GET_TOKEN_USER = 'GET_TOKEN_USER';
export const GET_TOKEN_USER_FAILED = 'GET_TOKEN_USER_FAILED';
export const GET_TOKEN_USER_SUCCEEDED = 'GET_TOKEN_USER_SUCCEEDED';

export const REQUEST_RECOVER_USER = 'REQUEST_RECOVER_USER';
export const RECOVER_USER_FAILED = 'RECOVER_USER_FAILED';
export const RECOVER_USER_SUCCEEDED = 'RECOVER_USER_SUCCEEDED';

export const VALID_TOKEN_RECOVERY = 'VALID_TOKEN_RECOVERY';
export const VALID_TOKEN_RECOVERY_FAILED = 'VALID_TOKEN_RECOVERY_FAILED';
export const VALID_TOKEN_RECOVERY_SUCCEEDED = 'VALID_TOKEN_RECOVERY_SUCCEEDED';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD_RECOVERY';
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED';
export const CHANGE_PASSWORD_SUCCEEDED = 'CHANGE_PASSWORD_SUCCEEDED';

export const REQUEST_CONFIRMATION_EMAIL = 'REQUEST_CONFIRMATION_EMAIL';
export const REQUEST_CONFIRMATION_EMAIL_FAILED = 'REQUEST_CONFIRMATION_EMAIL_FAILED';
export const REQUEST_CONFIRMATION_EMAIL_SUCCEEDED = 'REQUEST_CONFIRMATION_EMAIL_SUCCEEDED';

export const FINISH_SHOPPING = 'FINISH_SHOPPING';
export const SET_CART = "SET_CART";
export const SET_PRODUCTS_USER = "SET_PRODUCTS_USER"

/* actualizar estados desde la Storage */
export const SET_UPDATE_SESSION_USER = 'SET_UPDATE_SESSION_USER';

export const SET_USER_SESSION_TIME = 'SET_USER_SESSION_TIME';

export function getToken({username, password}, callback) {
    return {
        type: GET_TOKEN_USER,
        username,
        password,
        callback
    }
}

export function getTokenUserFailed(payload){
    return {
        type: GET_TOKEN_USER_FAILED,
        error: payload.error,
        message: payload.message
    }
}

export function getTokenUserSucceeded({token, ruta, usuario}){
    return {
        type: GET_TOKEN_USER_SUCCEEDED,
        token,
        ruta,
        usuario
    }
}

export function recoverUser(username){
    return {
        type: REQUEST_RECOVER_USER,
        username
    }
}

export function recoverUserFailed(error){
    return {
        type: RECOVER_USER_FAILED,
        error
    }
}

export function recoverUserSucceeded(success){
    return {
        type: RECOVER_USER_SUCCEEDED,
        success
    }
}

export function validToken(rol, token, callback){
    return {
        type: VALID_TOKEN_RECOVERY,
        rol,
        token,
        callback
    }
}

export function validTokenFailed(error){
    return {
        type: VALID_TOKEN_RECOVERY_FAILED,
        error
    }
}

export function validTokenSucceeded(success){
    return {
        type: VALID_TOKEN_RECOVERY_SUCCEEDED,
        success
    }
}

export function chengePassword(action, token, callback){
    return {
        type: CHANGE_PASSWORD,
        password: action.password,
        confirmPassword: action.confirmPassword,
        token,
        callback
    }
}

export function chengePasswordFailed(error){
    return {
        type: CHANGE_PASSWORD_FAILED,
        error
    }
}

export function chengePasswordSucceeded(success){
    return {
        type: CHANGE_PASSWORD_SUCCEEDED,
        success
    }
}

export function setUserSessionTime({startingTime, endingTime}){
    return {
        type: SET_USER_SESSION_TIME,
        startingTime,
        endingTime
    }
}

export function requestConfirmationEmail(email){
    return {
        type: REQUEST_CONFIRMATION_EMAIL,
        email
    }
}
export function requestConfirmationEmailFailed(){
    return {
        type: REQUEST_CONFIRMATION_EMAIL_FAILED,
    }
}

export function requestConfirmationEmailSucceeded(){
    return {
        type: REQUEST_CONFIRMATION_EMAIL_SUCCEEDED,
    }
}

export function finishShopping(){
    return {
        type: FINISH_SHOPPING
    }
}

export function setCart(cart){
    return {
        type: SET_CART,
        cart
    }
}

export function setProducts(products){
    return {
        type: SET_PRODUCTS_USER,
        products
    }
}

export const actions = {
    getToken,
    setUserSessionTime,
    recoverUser,
    validToken,
    chengePassword,
    requestConfirmationEmail,
    finishShopping,
    setCart,
    setProducts
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {

    [GET_TOKEN_USER]: (state, action) => ({
        ...state,
        getTokenUserStatus: API_REQUEST_STATUS_LOADING,
        getTokenUserError: -1,
        loading: true,
        loginErrorMessage: '',
        confirmationEmailStatus: -1
    }),

    [GET_TOKEN_USER_FAILED]: (state, action) => ({
        ...state,
        getTokenUserStatus: API_REQUEST_STATUS_FAILED,
        getTokenUserError: -1,
        loading: false,
        loginErrorMessage: action.message
    }),

    [GET_TOKEN_USER_SUCCEEDED]: (state, {ruta, usuario}) => ({
        ...state,
        ruta: ruta,
        usuario: usuario,
        getTokenUserStatus: API_REQUEST_STATUS_SUCCEEDED,
        loading: false
    }),

    [REQUEST_RECOVER_USER]: (state, action) => ({
        ...state,
        loading: true
    }),

    [RECOVER_USER_FAILED]: (state, action) => ({
        ...state,
        loading: false,
        errorMessage: 'Hubo un error, intentarlo más tarde'
    }),

    [RECOVER_USER_SUCCEEDED]: (state, {success}) => ({
        ...state,
        emailSent: success,
        loading: false,
        errorMessage: ''
    }),

    [VALID_TOKEN_RECOVERY]: (state, action) => ({
        ...state,
        loading: true
    }),

    [VALID_TOKEN_RECOVERY_FAILED]: (state, action) => ({
        ...state,
        loading: false,
        errorMessage: 'Hubo un error, intentarlo más tarde'
    }),

    [VALID_TOKEN_RECOVERY_SUCCEEDED]: (state, {success}) => ({
        ...state,
        tokenValido: success,
        loading: false,
        errorMessage: ''
    }),

    [CHANGE_PASSWORD]: (state, action) => ({
        ...state,
        loading: true
    }),

    [CHANGE_PASSWORD_FAILED]: (state, action) => ({
        ...state,
        loading: false,
        changePasswordStatus: API_REQUEST_STATUS_FAILED
    }),

    [CHANGE_PASSWORD_SUCCEEDED]: (state, {success}) => ({
        ...state,
        loading: false,
        changePasswordStatus: API_REQUEST_STATUS_SUCCEEDED
    }),

    [SET_USER_SESSION_TIME] : (state, {startingTime, endingTime}) => ({
        ...state,
        initSessionTime: startingTime,
        endSessionTime: endingTime
    }),

    [REQUEST_CONFIRMATION_EMAIL] : (state, action) => ({
        ...state,
        loading: true,
        loginErrorMessage: ''
    }),

    [REQUEST_CONFIRMATION_EMAIL_FAILED] : (state, action) => ({
        ...state,
        loading: false,
        confirmationEmailStatus: API_REQUEST_STATUS_FAILED
    }),

    [REQUEST_CONFIRMATION_EMAIL_SUCCEEDED] : (state, action) => ({
        ...state,
        loading: false,
        confirmationEmailStatus: API_REQUEST_STATUS_SUCCEEDED
    }),

    [FINISH_SHOPPING]: (state, payload) => ({
        ...state,
        finishedShopping: true
    }),

    [SET_CART]: (state, {cart}) => ({
        ...state,
        cart
    }),

    [SET_PRODUCTS_USER]: (state, {products}) => ({
        ...state,
        products
    })
};

const initialState = {
    ruta : '',
    usuario : '',
    userName : '',
    getTokenUserStatus : -1,
    getTokenUserError : -1,
    initSessionTime: null,
    endSessionTime: null,
    loading: false,
    emailSent: false,
    loginErrorMessage: '',
    errorMessage: '',
    changePasswordStatus: -1,
    tokenValido: true,
    confirmationEmailStatus: -1,
    finishedShopping: false,
    cart: [],
    answers: [],
    products: {}
};

export default function userReducer (state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type]

    return handler ? handler(state, action) : state
}


// WEBPACK FOOTER //
// ./src/store/modules/module_user.js